import React from 'react';

interface SVGProps {
  className?: string;
  width?: number | string;
  height?: number | string;
}

export const TuneyLogo: React.FC<SVGProps> = ({ 
  className = "", 
  width = 128, 
  height = 128 
}) => (
  <svg 
    fill="none" 
    viewBox="0 0 176 175"
    width={width}
    height={height}
    className={className}
  >
    <mask id="tuney-mask" width="132" height="89" x="22" y="42" maskUnits="userSpaceOnUse" style={{maskType: 'luminance'}}>
      <path fill="#fff" d="M153.625 42.116H22.375v88.034h131.25V42.116Z"/>
    </mask>
    <g mask="url(#tuney-mask)">
      <path fill="#6E4AF6" d="M117.177 42.783c-19.039 0-34.53 16.15-34.53 36.001v15.33c0 7.935-5.86 14.401-13.062 14.401-7.2 0-13.06-6.461-13.06-14.402V43.136h-32.47v21.602h10.993v29.375c0 19.852 15.49 36.003 34.531 36.003 19.041 0 34.538-16.147 34.538-36.003V78.781c0-7.936 5.859-14.4 13.06-14.4 7.201 0 13.062 6.46 13.062 14.4v51.366h21.47V78.781c0-19.847-15.491-35.998-34.532-35.998Z"/>
      <path fill="url(#tuney-gradient-b)" d="M117.177 42.783c-19.039 0-34.53 16.15-34.53 36.001v15.33c0 7.935-5.86 14.401-13.062 14.401-7.2 0-13.06-6.461-13.06-14.402V43.136h-32.47v21.602h10.993v29.375c0 19.852 15.49 36.003 34.531 36.003 19.041 0 34.538-16.147 34.538-36.003V78.781c0-7.936 5.859-14.4 13.06-14.4 7.201 0 13.062 6.46 13.062 14.4v51.366h21.47V78.781c0-19.847-15.491-35.998-34.532-35.998Z"/>
      <path fill="url(#tuney-gradient-c)" d="M117.177 42.783c-19.039 0-34.53 16.15-34.53 36.001v15.33c0 7.935-5.86 14.401-13.062 14.401-7.2 0-13.06-6.461-13.06-14.402V43.136h-32.47v21.602h10.993v29.375c0 19.852 15.49 36.003 34.531 36.003 19.041 0 34.538-16.147 34.538-36.003V78.781c0-7.936 5.859-14.4 13.06-14.4 7.201 0 13.062 6.46 13.062 14.4v51.366h21.47V78.781c0-19.847-15.491-35.998-34.532-35.998Z"/>
      <path fill="url(#tuney-gradient-d)" d="M117.177 42.783c-19.039 0-34.53 16.15-34.53 36.001v15.33c0 7.935-5.86 14.401-13.062 14.401-7.2 0-13.06-6.461-13.06-14.402V43.136h-32.47v21.602h10.993v29.375c0 19.852 15.49 36.003 34.531 36.003 19.041 0 34.538-16.147 34.538-36.003V78.781c0-7.936 5.859-14.4 13.06-14.4 7.201 0 13.062 6.46 13.062 14.4v51.366h21.47V78.781c0-19.847-15.491-35.998-34.532-35.998Z"/>
    </g>
    <defs>
      <radialGradient id="tuney-gradient-b" cx="0" cy="0" r="1" gradientTransform="matrix(127.264 -144.955 217.91 193.655 24.054 133.482)" gradientUnits="userSpaceOnUse">
        <stop stopColor="#6E4AF6"/>
        <stop offset="1" stopColor="#1D1D1D" stopOpacity="0"/>
      </radialGradient>
      <radialGradient id="tuney-gradient-c" cx="0" cy="0" r="1" gradientTransform="matrix(-45.6654 -69.6828 60.3906 -40.06 151.709 122.867)" gradientUnits="userSpaceOnUse">
        <stop stopColor="#7AF992"/>
        <stop offset="1" stopColor="#7CFF95" stopOpacity="0"/>
      </radialGradient>
      <radialGradient id="tuney-gradient-d" cx="0" cy="0" r="1" gradientTransform="matrix(52.5 60.523 -88.4353 77.6505 15.693 32.544)" gradientUnits="userSpaceOnUse">
        <stop stopColor="#B61E87"/>
        <stop offset="1" stopColor="#BF218E" stopOpacity="0"/>
      </radialGradient>
    </defs>
  </svg>
);
